<script>
    import { createEventDispatcher } from 'svelte';
    import { Table, Icon, Input, Button, Card, CardBody, Spinner,
             Modal, ModalBody, ModalFooter, ModalHeader } from 'sveltestrap';
    import SortableList from 'svelte-sortable-list';
    import MediaDuration from './MediaDuration.svelte';
    import BlockAdd from './BlockAdd.svelte';

    export let server;
    export let token;
    export let login;
    export let password;
    export let haveBlocks;
    export let media;
    export let savedBlocks;
    export let allMedia;

    let changed = false;
    let id = 1;
    let openPlayModal = false;
    let playPromise;

    const dispatch = createEventDispatcher();

    function change(event) {
        changed = true;
    }

    function sortBlock(event) {
        media.block = event.detail.map(obj => {
            return obj.mediaId;
        });
        changed = true;
    }

    function unsetBlock(item) {
        let position = blockList.findIndex((obj) => obj.id == item.id);
        console.log(position);
        media.block.splice(position, 1);
        media = media; /* Force update */
        changed = true;
    }

    function duplicateBlock(item) {
        let position = blockList.findIndex((obj) => obj.id == item.id);
        console.log(position);
        media.block.splice(position, 0, item.mediaId);
        media = media; /* Force update */
        changed = true;
    }

	async function getSmartMediaList(arg) {
        const response = await fetch(server + "/rest/media?" +
            new URLSearchParams({ select: "media_id", ...arg}), {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token
                }
		});
		const json = await response.json();

		if (response.ok) {
			return json;
		} else {
			throw new Error(response.status);
		}
	}

    async function getPlaylist(mediaId) {
        if (typeof(allMedia[mediaId]) == 'undefined')
            return [];

        let current = allMedia[mediaId];
        if (current.block) {
            let playlist = [];
            for (let i = 0; i < current.block.length; i++) {
                let element = current.block[i];
                if (element != mediaId) {
                    let blockPlaylist = await getPlaylist(element);
                    playlist = [...playlist, ...blockPlaylist];
                }
            }
            return playlist;

        } else if (current.smart) {
            if (!current.smartMedia)
                current.smartMedia = await getSmartMediaList(JSON.parse(current.smart));
            if (!current.smartMedia.length)
                return [];
            let randomElement = current.smartMedia[Math.floor(Math.random() * current.smartMedia.length)];
            return [randomElement.media_id];

        } else {
            return [mediaId];
        }
    }

    function playConfirm(event) {
        playPromise = getPlaylist(media.media_id);
        openPlayModal = true;
    }

    function togglePlayModal() {
        openPlayModal = !openPlayModal;
    }

	async function uploadPlaylist(file) {
        const response = await fetch(server + "/cgi-bin/play.pl", {
                method: 'PUT',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Content-Type': 'text/plain',
                    'Authorization': "Basic " + btoa(login + ":" + password)
                },
                body: file
		});

		if (response.ok) {
			return;
		} else {
			throw new Error(response.status);
		}
	}

    function play(playlist) {
        let file = playlist.map((element) => {
            return element + ".ts";
        });
        let uploadPromise = uploadPlaylist(file.join("\n") + "\n");
        uploadPromise.then(() => {
            openPlayModal = false;
        });
        uploadPromise.catch((error) => {
            alert(error);
        });
    }

    function getBlockList(media) {
        let list = [];
        if (!media.block)
            return list;
        media.block.forEach(mediaId => {
            if (typeof(allMedia[mediaId]) != 'undefined')
                list.push({ id: id++, mediaId: mediaId, name: allMedia[mediaId].name });
        });
        return list;
    }

    function getUrl(mediaId) {
        let url = new URL(server + "/repository/" + mediaId + ".ts");
        url.username = login;
        url.password = password;
        return url.href;
    }

    $: checked = { [media.media_id]: "success" };
    $: blockList = getBlockList(media);
    $: mediaUrl = getUrl(media.media_id);
</script>

<Table striped><tbody>
    <tr>
        <th>Name</th>
        <td><Input type="text" bind:value={media.name} on:input={change} /></td>
    </tr>
    {#if media.smart}
        <tr>
            <th>Expression</th>
            <td><Input type="text" bind:value={media.smart} on:input={change} /></td>
        </tr>
    {:else if !media.block}
        <tr>
            <th>Directory</th>
            <td><Input type="text" bind:value={media.dir} on:input={change} /></td>
        </tr>
    {/if}
    <tr>
        <th>Creation</th>
        <td><Input type="text" bind:value={media.creation} /></td>
    </tr>
    {#if !media.smart && !media.block}
        <tr>
            <th>Duration</th>
            <td><MediaDuration duration={media.duration} /></td>
        </tr>
    {/if}
</tbody></Table>
{#if blockList.length}
    <SortableList list={blockList} on:sort={sortBlock} key=id let:item>
        <Card>
            <CardBody><div class="blockList">
                <span on:click={() => unsetBlock(item)}>
                    <Icon name="x" />
                </span>
                <span on:click={() => duplicateBlock(item)}>
                    <Icon name="files" />
                </span>
                {item.name}
            </div></CardBody>
        </Card>
    </SortableList>
{/if}

<p>
    <Button type="button" color="success" disabled={!changed} on:click={() => dispatch('patch', media)}><Icon name="pencil-fill" /></Button>
    {#if haveBlocks}
        <BlockAdd {checked} {savedBlocks} on:patch />
    {/if}
    <Button type="button" color="success" on:click={playConfirm}><Icon name="play-fill" /> Play now</Button>
    <Button type="button" color="danger" on:click={() => dispatch('delete', media)}><Icon name="trash-fill" /></Button>
</p>
{#if !media.smart && !media.block}
    <video src={mediaUrl} width="100%" controls>
        <track kind="captions">
        Video not supported
    </video>
{/if}

<Modal isOpen={openPlayModal} toggle={togglePlayModal}>
    <ModalHeader toggle={togglePlayModal}>Warning</ModalHeader>
    <ModalBody>
        This will erase the current playlist, and replace it with the following. Do you confirm?<br />
        {#await playPromise}
            <Spinner primary size="bg" />
        {:then playlist}
            <div class="playlist">
                {#each playlist as item}
                    {allMedia[item].name}<br />
                {/each}
            </div>
        {:catch error}
            <p class="error">Error: {error}</p>
        {/await}
    </ModalBody>
    <ModalFooter>
        {#await playPromise}
            <Spinner primary size="bg" />
        {:then playlist}
            {#if haveBlocks}
                <Button color="secondary" on:click={playConfirm}><Icon name="arrow-repeat" /> Regenerate</Button>
            {/if}
        {/await}
        <Button color="primary" on:click={togglePlayModal}>Cancel</Button>
        {#await playPromise}
            <Spinner primary size="bg" />
        {:then playlist}
            <Button color="secondary" on:click={play(playlist)}><Icon name="play-fill" /> Confirm</Button>
        {:catch error}
            <Button color="secondary" disabled><Icon name="play-fill" /> Confirm</Button>
        {/await}
    </ModalFooter>
</Modal>

<style>
    .blockList {
        cursor: pointer;
    }
    .error {
        margin-top: 1em;
        font-weight: bold;
        color: red;
    }
    .playlist {
        overflow: auto;
        margin: 1em;
    }
</style>